export default __webpack_public_path__ + "images/SW.fe8d999.png";